/**
 * Name: main.js
 * Description: Main entry point.
 * Created by: Jana Schumann on 2019-11-05
 * Last edited by: Andjelka Popovic on 2025-12-30
 */

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import { createI18n, I18nT } from "vue-i18n";
import messages from "./lang";
import axiosInstance from './api';

//Vue.config.productionTip = false;

export const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
  inheritLocale: false,
  globalInjection: true,
  legacy: false
});

const app = createApp(App)
app.use(vuetify)
app.use(i18n)
app.use(router)
app.component('i18n-t', I18nT)
app.config.globalProperties.$axios = axiosInstance

router.isReady().then(() => {
  app.mount('#app')
})